import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { selectSessionById } from "../../../store/mine_craft/sessionsSlice";
import { fetchSession } from "../../../actions/mine_craft/sessionsActions";

import PageLayout from "../_partials/PageLayout";
import SummaryShow from "../../../componets/SummaryShow";
import Details from "./_partials/_Details";
import Tabs from "../../../componets/Tabs";
import SidebarShow from "../Sessions/_partials/_SidebarShow";

const Show: React.FC = () => {
  const { id } = useParams();
  const dispatch = useAppDispatch();
  const session = useAppSelector(state => id ? selectSessionById(state, id) : undefined);

  useEffect(() => {
    if (id) {
      dispatch(fetchSession(id));
    }
  }, [id, dispatch]);

  return (
    <PageLayout className='v-sessions-show'>
      <div className='v-container-fluid'>
        <div className='o-header'>
          {
            session &&
              <SummaryShow
                title={session.uid}
                createdAt={session.created_at}
                updatedAt={session.updated_at}
                className='v-mb-15'
              />
          }

          <Tabs
            paramsKey='tab'
            destroyInactiveTabPane={true}
            items={[
              { label: 'Details', key: 'details', children: <Details session={session} /> }
            ]}
          />
        </div>
      </div>

      <SidebarShow session={session} />
    </PageLayout>
  )
}

export default Show;
